import { SignupUserTemplate } from '../templates'

export const SignUpPage = () => {
  return (
    <SignupUserTemplate />
  )
}